module.exports = __webpack_public_path__ + "img/size8.9c5dc644.png";